import { buildAccountCache } from './buildAccountCache';
import { dedupeByEbsId } from './dedupeVolumes';
import {
  ensureOrgMemberCaches,
  getOrgMemberAccountIds,
  orgKeyForParent,
  type OrgParentEntry,
} from './orgVolumeUtils';
import { stampOrgChildParentIds } from './stampOrgChildParentIds';
import { stampVolumeAccountNames } from './stampVolumeAccountNames';
import type { ExplorationAccountCache, ExplorationVolume } from '../types/exploration';

export function buildOrgAggregateCache(
  caches: Record<string, ExplorationAccountCache>,
  entry: OrgParentEntry,
  nameMap: Record<string, string>
): void {
  ensureOrgMemberCaches(caches, entry, nameMap);
  stampOrgChildParentIds(caches, entry.childAccountIds, entry.accountId);

  const orgVols: ExplorationVolume[] = [];
  getOrgMemberAccountIds(entry).forEach((id) => {
    const cache = caches[id];
    if (cache?.volumes) orgVols.push(...cache.volumes);
  });

  const orgDeduped = stampVolumeAccountNames(dedupeByEbsId(orgVols), nameMap);
  const orgKey = orgKeyForParent(entry.accountId);
  caches[orgKey] = {
    ...buildAccountCache(orgKey, entry.name, orgDeduped),
    _isOrgAggregate: true,
    _orgParentId: entry.accountId,
    _orgChildIds: entry.childAccountIds,
    _isVirtualOrg: entry.isVirtual,
  };
}
